(function () {
  // carousel_horizontal中每一页宽度的设置
  function setCarouselHorizontalPageWidth() {
    const carousel_horizontal = document.getElementsByClassName('carousel_horizontal')
    let timeoutid = -1

    function _setCarouselHorizontalPageWidth() {
      for (let i = 0; i < carousel_horizontal.length; i++) {
        const carouselHorizontalWrap = carousel_horizontal[i].getElementsByClassName('carousel_horizontal-wrap')[0]
        const carouselHorizontalCol = carousel_horizontal[i].getElementsByClassName('carousel_horizontal-col')
        const carouselHorizontalRow = carousel_horizontal[i].getElementsByClassName('carousel_horizontal-row')[0]
        const privateTrafficTabs = document.getElementsByClassName('private-traffic-tabs')[0].getElementsByTagName('div')

        let totalWidth = 0
        for (let j = 0; j < carouselHorizontalCol.length; j++) {
          totalWidth += carouselHorizontalWrap.offsetWidth
          carouselHorizontalCol[j].style.width = carouselHorizontalWrap.offsetWidth + 'px'
        }
        carouselHorizontalRow.style.width = totalWidth + 'px'
        carouselHorizontalRow.style.left = '0px'

        if (carousel_horizontal[i].parentElement.getAttribute('id') == 'private-traffic') {
          totalWidth = 0
          for (let j = 0; j < privateTrafficTabs.length; j++) {
            if (privateTrafficTabs[j].dataset.hover) break
            totalWidth += carouselHorizontalCol[j].offsetWidth
            carouselHorizontalRow.style.left = '-' + totalWidth + 'px'
          }
        }
        
      }
    }

    window.addEventListener('resize', debounce(_setCarouselHorizontalPageWidth, 200))

    _setCarouselHorizontalPageWidth()


    function _addEvent() {
      for (let i = 0; i < carousel_horizontal.length; i++) {
        const carouselHorizontalWrap = carousel_horizontal[i].getElementsByClassName('carousel_horizontal-wrap')[0]
        const carouselHorizontalCol = carousel_horizontal[i].getElementsByClassName('carousel_horizontal-col')
        const carouselHorizontalRow = carousel_horizontal[i].getElementsByClassName('carousel_horizontal-row')[0]
        const carouselHorizontalItems = carousel_horizontal[i].getElementsByClassName('carousel_horizontal_item')
        const privateTrafficTabs = carousel_horizontal[i].getElementsByClassName('private-traffic-tabs')[0]
        let controllerLeft = carouselHorizontalWrap.getElementsByClassName('controller-left')[0]
        if (controllerLeft) {
          controllerLeft = controllerLeft.getElementsByTagName('span')[0]
        }
        let controllerRight = carouselHorizontalWrap.getElementsByClassName('controller-right')[0]
        if (controllerRight) {
          controllerRight = controllerRight.getElementsByTagName('span')[0]
        }
        const meta = carousel_horizontal[i].getElementsByClassName('meta')
        const pageInfoPosition = meta[0] ? meta[0].dataset.pip : null
        const pageInfo = null
        const subtitleDiv = meta[0] ? meta[0].getElementsByClassName('subtitle')[0] : null
        const subtitleSpans = subtitleDiv ? subtitleDiv.getElementsByTagName('span') : null

        if (pageInfoPosition !== null && pageInfoPosition !== 'none') {
          pageInfo = meta[0].querySelector('.page-info[data-' + pageInfoPosition + ']')
        }

        // 下一页
        function next(event) {
          //调整Tab高亮
          if (privateTrafficTabs) {
            const privateTrafficTab = privateTrafficTabs.getElementsByClassName('private-traffic-tab')
            let temp = 0;
            for (let i = 0; i < privateTrafficTab.length; i++) {
              if (privateTrafficTab[i].dataset.hover) {
                temp = i
                delete privateTrafficTab[i].dataset.hover
              }
            }
            temp = (temp === privateTrafficTab.length - 1) ? temp = 0 : temp + 1
            privateTrafficTab[temp].dataset.hover = true
          }
          if (-parseFloat(carouselHorizontalRow.style.left) + 20 >= carouselHorizontalRow.offsetWidth - carouselHorizontalCol[0].offsetWidth) {
            // 恢复到第一页
            carouselHorizontalRow.style.left = 0
            if (pageInfo) {
              const _pageInfo = pageInfo.innerText.split('/')
              pageInfo.innerText = 1 + '/' + _pageInfo[1]
            }
            if (subtitleSpans != null)
              for (let j = 0; j < subtitleSpans.length; j++) {
                if (subtitleSpans[j].dataset.index === '0') {
                  subtitleSpans[j].style.display = 'inline'
                } else {
                  subtitleSpans[j].style.display = 'none'
                }
              }

            return
          }
          carouselHorizontalRow.style.left = (parseFloat(carouselHorizontalRow.style.left) || 0) - carouselHorizontalCol[0].offsetWidth + 'px'

          // 更新页码
          let _pageInfo = pageInfo.innerText.split('/')
          if (pageInfo) {
            pageInfo.innerText = parseInt(_pageInfo[0]) + 1 + '/' + _pageInfo[1]
          }

          // 更新subtitle
          if (subtitleSpans != null)
            for (let j = 0; j < subtitleSpans.length; j++) {
              if (subtitleSpans[j].dataset.index === parseInt(_pageInfo[0]) + '') {
                subtitleSpans[j].style.display = 'inline'
              } else {
                subtitleSpans[j].style.display = 'none'
              }
            }
        }

        // 上一页
        function prev() {
          if (privateTrafficTabs) {
            const privateTrafficTab = privateTrafficTabs.getElementsByClassName('private-traffic-tab')
            delete privateTrafficTab[1].dataset.hover
            privateTrafficTab[0].dataset.hover = true
          }

          if (!carouselHorizontalRow.style.left || parseFloat(carouselHorizontalRow.style.left) >= 0) {
            return
          }
          carouselHorizontalRow.style.left = (parseFloat(carouselHorizontalRow.style.left) || 0) + carouselHorizontalCol[0].offsetWidth + 'px'

          // 更新页码
          let _pageInfo = pageInfo.innerText.split('/')
          if (pageInfo) {
            pageInfo.innerText = parseInt(_pageInfo[0]) - 1 + '/' + _pageInfo[1]
          }

          // 更新subtitle 
          if (subtitleSpans != null) {
            for (let j = 0; j < subtitleSpans.length; j++) {
              if (subtitleSpans[j].dataset.index === parseInt(_pageInfo[0]) - 2 + '') {
                subtitleSpans[j].style.display = 'inline'
              } else {
                subtitleSpans[j].style.display = 'none'
              }
            }
          }
        }

        if (controllerLeft && controllerRight) {
          controllerLeft.addEventListener('click', throttle(() => {
            carouselHorizontalSwipter('prev')
          }, 1000))
          controllerRight.addEventListener('click', throttle(() => {
            carouselHorizontalSwipter()
          }, 1000))
        }

        if (privateTrafficTabs) {
          const privateTrafficTab = privateTrafficTabs.getElementsByClassName('private-traffic-tab')
          privateTrafficTab[0].addEventListener('click', throttle(() => {
            carouselHorizontalSwipter('prev')
          }, 1000))
          privateTrafficTab[1].addEventListener('click', throttle(() => {
            carouselHorizontalSwipter()
          }, 1000))
        }

        function carouselHorizontalItemHover(event) {
          Array.from(carouselHorizontalItems).forEach(carouselHorizontalItem => {
            delete carouselHorizontalItem.dataset.hover
          })

          event.target.dataset.hover = true
        }

        Array.from(carouselHorizontalItems).forEach(carouselHorizontalItem => {
          carouselHorizontalItem.addEventListener('touchstart', debounce(carouselHorizontalItemHover, 100))
        })


        //carouselHorizontal轮播
        function carouselHorizontalSwipter(direction) {
          //重置计时
          clearTimeout(timeoutid)
          if (direction === 'prev') {
            prev()
          } else {
            next()
          }
          timeoutid = setTimeout(carouselHorizontalSwipter.bind(this), 7000)
        }
        timeoutid = setTimeout(carouselHorizontalSwipter.bind(this), 7000)
      }
    }

    _addEvent()
  }

  setCarouselHorizontalPageWidth()

})()